"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DataStatus = exports.statusTypes = void 0;

var _react = _interopRequireDefault(require("react"));

require("./DataStatus.scss");

var _settings = _interopRequireDefault(require("../../asset/icons/settings.svg"));

var _search_big = _interopRequireDefault(require("../../asset/icons/search_big.svg"));

var _round_spa = _interopRequireDefault(require("../../asset/icons/round_spa.svg"));

var _person_add = _interopRequireDefault(require("../../asset/icons/person_add.svg"));

var _warning = _interopRequireDefault(require("../../asset/icons/warning.svg"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var statusTypes = {
  NO_PRODUCTS: 'NO_PRODUCTS',
  NO_RESULTS: 'NO_RESULTS',
  NO_PEOPLE: 'NO_PEOPLE',
  LOADING: 'LOADING',
  DISABLED: 'DISABLED',
  DELETE: 'DELETE'
};
exports.statusTypes = statusTypes;

var getStatusObj = function getStatusObj(status) {
  switch (status) {
    case statusTypes.NO_PRODUCTS:
      return {
        src: _round_spa["default"],
        altText: 'leafy product icon',
        subTitleText: 'No products added yet.'
      };

    case statusTypes.NO_PEOPLE:
      return {
        src: _person_add["default"],
        altText: 'add person icon',
        subTitleText: 'No people added yet.'
      };

    case statusTypes.LOADING:
      return {
        src: _settings["default"],
        altText: 'gear icon',
        subTitleText: 'Loading...'
      };

    case statusTypes.NO_RESULTS:
    default:
      return {
        src: _search_big["default"],
        altText: 'magnifying glass icon',
        subTitleText: 'No results'
      };

    case statusTypes.DELETE:
      return {
        src: _warning["default"],
        altText: 'warning icon',
        subTitleText: 'Permanently delete this asset?'
      };
  }
};

var DataStatus = function DataStatus(props) {
  var statusObj = getStatusObj(props.status);

  if (props.status !== statusTypes.DISABLED) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "status-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: props.status === statusTypes.DELETE ? 'warning' : 'image-container'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: props.status === statusTypes.LOADING ? 'gear' : '',
      alt: statusObj.altText,
      src: statusObj.src
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "status-subtitle-text",
      "data-testid": "data_status_subtitle"
    }, statusObj.subTitleText));
  } else return null;
};

exports.DataStatus = DataStatus;
var _default = DataStatus;
exports["default"] = _default;
DataStatus.propTypes = {
  status: _propTypes.string
};